import React from "react";
import { Dialog, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Button from "../../../../components/common/PL/Button/Button";
import useStyles from "./ReservationActionModalStyles";

export type ReservationActionModalVariant = "success" | "error";

interface ReservationActionModalProps {
  open: boolean;
  variant: ReservationActionModalVariant;
  title: string;
  description: string;
  onBackToStart: () => void;
}

export const ReservationActionModal = ({
  open,
  variant,
  title,
  description,
  onBackToStart,
}: ReservationActionModalProps) => {
  const classes = useStyles();
  const titleClass = variant === "success" ? classes.successTitle : classes.errorTitle;

  return (
    <Dialog open={open} disableEscapeKeyDown classes={{ paper: classes.paper }}>
      <div className={classes.content}>
        <div className={`${classes.iconCircle} ${classes[variant]}`}>
          {variant === "success" ? <CheckIcon /> : <CloseIcon />}
        </div>
        <Typography className={`${classes.title} ${titleClass}`}>{title}</Typography>
        <Typography className={classes.description}>{description}</Typography>
        <div className={classes.actions}>
          <Button size="large" variant="neutral" onClick={onBackToStart}>
            Volver al inicio
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ReservationActionModal;
